import Plyr from 'plyr';

const initPlayer = (video, options) => {
	const player = new Plyr(video, {
		invertTime: false,
		...options,
	});
	player.on('ready', () => {
		player.play();
	});
};

export default initPlayer;
